import { Button, Card, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { downloadCSV, formatDate, getUserRole } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";

function NewCallDetailsTable() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [totalRecords, setTotalRecords] = useState(0);
    const [tableData, setTableData] = useState([]);
    const navigate = useNavigate();

    const { selectedDates, selectedHotels, kioskSelection } =
        useContext(SettingContext);
    const [start_date, end_date] = selectedDates;

    const hotel_ids = selectedHotels;
    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: "call_duration",
    });

    const [formData, setFormData] = useState({
        staff_id,
        page: 0,
        limit: 10,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        calling_hotel_type: kioskSelection,
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
    });

    const {
        status: newCallStatus,
        data: newCallRes,
        refetch: getNewCallDetails,
    } = useQuery(
        "newCallTable",
        async () => {
            return await HTTP("/dashboard/getNewCallsDetails", { ...formData });
        },
        { enabled: false },
    );

    useEffect(() => {
        getNewCallDetails();
    }, []);

    useEffect(() => {
        setFormData({
            ...formData,
            calling_hotel_type: kioskSelection,
        });
    }, [kioskSelection]);

    useEffect(() => {
        getNewCallDetails();
    }, [formData]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            page: 0,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    useEffect(() => {
        if (newCallStatus === "success") {
            const { data: tableData, total } = newCallRes;
            setTableData(tableData);
            setTotalRecords(total);
        }
    }, [newCallStatus, newCallRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }

        const newFormData = {
            ...formData,
            ...others,
        };

        setFormData(newFormData);
    }

    const column = [
        {
            title: "Hotel Name",
            dataIndex: "hotel_name",
            key: "hotel_name",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "hotel_name" ? sortedInfo.order : null,
        },
        {
            title: "Staff Name",
            dataIndex: "staff_name",
            key: "staff_name",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "staff_name" ? sortedInfo.order : null,
        },
        {
            title: "Call From",
            dataIndex: "call_start_by",
            key: "call_start_by",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "call_start_by"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Call Id",
            dataIndex: "call_id",
            key: "call_id",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "call_id" ? sortedInfo.order : null,
        },
        {
            title: "Duration",
            dataIndex: "call_duration",
            key: "call_duration",
            sorter: () => {},
            width: 100,
            sortOrder:
                sortedInfo.columnKey === "call_duration"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Start Time",
            dataIndex: "call_start_time",
            key: "call_start_time",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "call_start_time"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Operation Id",
            dataIndex: "operation_id",
            key: "operation_id",
            render: (text, record) => (
                <Button
                    type="link"
                    onClick={getCallData}
                    operationid={record.operation_id}
                    callid={record.call_id}
                    staffid={record.staff_id}
                    id={record.hotel_id}
                    hotelname={text}
                >
                    {text}
                </Button>
            ),
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "operation_id"
                    ? sortedInfo.order
                    : null,
        },
    ];

    function getCallData(e) {
        const operation_id = e.currentTarget.getAttribute("operationid");
        const call_id = e.currentTarget.getAttribute("callid");
        const staff_id = e.currentTarget.getAttribute("staffid");
        navigate("/call-time", { state: { operation_id, call_id, staff_id } });
    }

    async function downalodReport() {
        const tempFormData = { ...formData };
        delete tempFormData["page"];
        delete tempFormData["limit"];
        const res = await HTTP("/dashboard/getNewCallsDetailsReport", {
            ...tempFormData,
        });
        downloadCSV(res, `call_details_reports`);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    (getUserRole() == "Super Admin" ||
                        getUserRole() == "Admin" ||
                        getUserRole() == "Management") && (
                        <Button
                            type="primary"
                            className="margin-right-5"
                            onClick={downalodReport}
                        >
                            Download
                        </Button>
                    )
                }
            />
            <Card className="box-shadow margin-10">
                {newCallStatus !== "loading" && newCallStatus !== "idle" ? (
                    <CustomTable
                        columns={column}
                        tableData={tableData}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        className="newCallsTable"
                        rowKey="operation_id"
                        isScroll
                    />
                ) : (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                )}
            </Card>
        </Card>
    );
}

export { NewCallDetailsTable };
